import { initializeApp, getApps } from 'firebase/app';
import { getAnalytics, logEvent, setUserProperties, setUserId } from 'firebase/analytics';

// Your existing Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCs4ynwRb8q-ftaWnGaBCdWZT1kunIMu90",
  authDomain: "actmobile-dda9d.firebaseapp.com",
  databaseURL: "https://actmobile-dda9d.firebaseio.com",
  projectId: "actmobile-dda9d",
  storageBucket: "actmobile-dda9d.firebasestorage.app",
  messagingSenderId: "728762119993",
  appId: "1:728762119993:web:cce4ae0bd14e1d21cb1ae8",
  measurementId: "G-JFP5KPRZH1"
};

// Initialize Firebase only if not already initialized
let app;
let analytics = null;

try {
  // Check if Firebase is already initialized
  const existingApps = getApps();
  if (existingApps.length > 0) {
    app = existingApps[0];
  } else {
    app = initializeApp(firebaseConfig);
  }
  
  // Initialize Analytics only in production and if window is defined
  if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
    analytics = getAnalytics(app);
  }
} catch (error) {
  console.error('Firebase initialization error:', error);
}

// Safe wrapper for logging events
export const logAnalyticsEvent = (eventName, eventParams = {}) => {
  try {
    // Add common properties to all events
    const enrichedParams = {
      ...eventParams,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      platform: navigator.platform,
      connectionType: navigator.connection?.effectiveType || 'unknown'
    };

    if (analytics) {
      logEvent(analytics, eventName, enrichedParams);
      console.log(`📊 Analytics Event: ${eventName}`, enrichedParams);
    } else {
      // In development, just log to console
      console.log(`📊 [DEV] Analytics Event: ${eventName}`, enrichedParams);
    }
  } catch (error) {
    // Silently fail - never break the app due to analytics
    console.warn('Analytics event failed:', error);
  }
};

// Set user properties safely
export const setAnalyticsUserProperties = (properties) => {
  try {
    if (analytics) {
      setUserProperties(analytics, properties);
    }
  } catch (error) {
    console.warn('Failed to set user properties:', error);
  }
};

// Set user ID safely
export const setAnalyticsUserId = (userId) => {
  try {
    if (analytics && userId) {
      setUserId(analytics, userId);
    }
  } catch (error) {
    console.warn('Failed to set user ID:', error);
  }
};